import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import {  Typography, Button, Snackbar} from '@material-ui/core';


import {
   ContentCopyOutlined,
     NumbersOutlined,
      OpenInNewOutlined
     } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({

  rowInfo: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'center',
    borderRadius: "0.5rem",
    marginTop: theme.spacing(0.5),
    paddingTop: theme.spacing(0.5),
    paddingLeft:  theme.spacing(1),
    paddingRight:  theme.spacing(1),
  },

  paymentInfo: {
    display: 'flex',
    flexDirection: 'column',
    width: "100%",
  },

  message: {
    margin: 0,
    padding: 0,
    textAlign: 'justify'
  },

  rowItem: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: "0.5rem",
    paddingBottom:  theme.spacing(1),
  },


  item: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'center',
    width: '80%',
    //backgroundColor:'yellow'
  },

}));




export default function OrderPaymentInfo(props) {
  const classes = useStyles();
  const {showInfo, isProgress, displayPaymentMethod, orderPayMethod, strings } = props;
  const [open, setOpen] = useState(false)
 
  //console.debug(" OrderPaymentInfo showInfo", showInfo);
  //console.debug(" OrderPaymentInfo showInfoProgress", isProgress);

  const handlerCopyPaymentKey = (key)=>{
    console.debug("handlerCopyPaymentKey",key);
    navigator.clipboard.writeText(key)
    setOpen(true);
  }

  const handlerCopylink = (link)=>{
    console.debug("handlerCopylink",link);
    navigator.clipboard.writeText(link)
    setOpen(true);
  }

  const handlerOpenPaymentLink = (link)=>{
    console.debug(" handlerPaymentLink",link);
    window.open(link, "_blank", "noreferrer");
  }

  const handleClose = () => {
    setOpen(false);
  };
  
  return (
   
      <div className={classes.rowInfo}>
       
         { 
            showInfo && !isProgress && 
            <div className={classes.paymentInfo}>
              {displayPaymentMethod.paymentInfo.message && 
                <Typography 
                  variant='body1'
                  align='left'
                  mb={1}
                  className={classes.message}>
                    {displayPaymentMethod.paymentInfo.message}
                </Typography>
              }
            
              {displayPaymentMethod.paymentInfo.key && 
                <div className={classes.rowItem}>
                  <div className={classes.item}>    
                    <NumbersOutlined/>
                    <Typography variant='body' mx={1} > {displayPaymentMethod.paymentInfo.key} </Typography>        
                  </div>
                <ContentCopyOutlined
                  onClick ={()=> handlerCopyPaymentKey(displayPaymentMethod.paymentInfo.key)}/>
                </div>
              }

              {displayPaymentMethod.paymentInfo.link && 
                  <div className={classes.rowItem}>
                    <div className={classes.item}>   
                    <Button 
                      onClick ={ ()=>handlerOpenPaymentLink(displayPaymentMethod.paymentInfo.link)}
                      variant="contained"
                        color='info'
                        startIcon={<OpenInNewOutlined/>} >
                          {strings.payment_link}
                          </Button>                  
                    </div>
                  
                  <ContentCopyOutlined 
                    onClick ={()=> handlerCopylink(displayPaymentMethod.paymentInfo.link)}/>
                </div>
              }
             </div>   
            }

            {  showInfo  && isProgress  && 
              <Typography 
              variant='body1'
              align='left'
              mb={1}
              className={classes.message}>
                {strings.ticket_request_wait_payment_info}
             </Typography>
            }
                      
         
        <Snackbar
          open={open}
          autoHideDuration={2000}
          onClose={handleClose}
          message={strings.copied_clipboard}
        />
      </div>
  );
}
